import { ComponentMultiStyleConfig } from "@chakra-ui/react";

import { mode } from "@chakra-ui/theme-tools";

const table: ComponentMultiStyleConfig = {
  parts: ["table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption"],
  sizes: {
    md: {
      td: {
        px: 4,
        py: 2
      },
      th: {
        px: 4,
        py: 2
      }
    }
  },
  variants: {
    // This will eventually be the default style but we want to be able to adopt
    // it incrementally so it's a separate variant for now.
    standard: (props) => ({
      table: {
        borderWidth: 1
      },
      th: {
        bg: mode("gray.100", "gray.800")(props),
        fontWeight: "bold",
        borderBottomWidth: 1,
        textTransform: "none",
        letterSpacing: "normal",
        fontSize: "inherit"
      },
      td: {
        borderBottomWidth: 1
      },
      tbody: {
        tr: {
          "&:nth-of-type(even)": {
            td: {
              background: mode("gray.50", "gray.600")(props)
            }
          }
        }
      }
    }),
    "report-table": (props) => ({
      table: {
        height: "fit-content",
        position: "relative",
        borderCollapse: "separate",
        borderSpacing: 0,
        zIndex: 0
      },
      tr: {
        "> th:first-of-type, > td:first-of-type": {
          position: "sticky",
          left: 0,
          width: "1%",
          textAlign: "left",
          boxShadow: `0px 0px 8px ${props.colorScheme}`,
          clipPath: "inset(0px -8px 0 0)",
          zIndex: 1
        }
      },
      th: {
        backgroundColor: mode("white", "gray.700")(props),
        borderWidth: "1px",
        textAlign: "right",
        whiteSpace: "nowrap"
      },
      td: {
        backgroundColor: mode("white", "gray.700")(props),
        borderWidth: "1px",
        textAlign: "right",
        whiteSpace: "nowrap"
      }
    })
  }
};

export default table;
